// src/utils/models/companyModel.js

export const createCompany = (data) => ({
  name: data.name || "",
  taxId: data.taxId || "",
  industry: data.industry || "",
  website: data.website || "",
  email: data.email || "",
  phone: data.phone || "",
  address: {
    street: data.address?.street || "",
    city: data.address?.city || "",
    state: data.address?.state || "",
    zipCode: data.address?.zipCode || "",
    country: data.address?.country || "España",
  },
  contacts: data.contacts || [], // array de contactIds asociados
  files: data.files || [],
  notes: data.notes || "",
  assignedTo: data.assignedTo || "",
  createdAt: data.createdAt || new Date().toISOString(),
  updatedAt: data.updatedAt || new Date().toISOString(),
  createdBy: data.createdBy || "",
  isActive: data.isActive !== undefined ? data.isActive : true,
  id: data.id || "",
});